export default __webpack_public_path__ + "static/media/swiss-flower-gel.fb98caba.jpg";